import React from "react";
import { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { Table, Form, Pagination } from "react-bootstrap";
import {
  faPlus,
  faSearch,
  faSort,
  faTrash,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  utilGetInventario,
  utilGetCollectionFilterReference,
  utilCreateInventario,
} from "../../../util/UtilsFirebase";
// styles
import "./inventario.css";
import ProductoModal from "./ProductoModal";

export default function Inventario() {
  const { register } = useAuthContext();
  const [inventario, setInventario] = useState([]);
  const [productos, setProductos] = useState([]);
  const [newCat] = useState(false);
  const [mod, setMod] = useState(null);
  const [itemProducto, setItemProducto] = useState(null);

  async function getInventario() {
    const fetchOrders = await utilGetCollectionFilterReference(
      "inventario",
      "registro",
      "==",
      register.id,
      "registro"
    );
    if (fetchOrders.length !== 0) {
      const invent = await utilGetInventario(fetchOrders[0].id);
      setInventario({
        ...invent,
        id: fetchOrders[0].id,
      });
      setProductos(invent.productos);
    } else {
      const invent = {
        registro: null,
      };
      const inventarioid = await utilCreateInventario(invent, register.id);
      const inventa = await utilGetInventario(inventarioid);
      setInventario({ ...inventa, id: inventarioid });
      setProductos(inventa.productos);
    }
  }

  useEffect(() => {
    getInventario();
  }, [register.id]);

  const [currentPage, setCurrentPage] = useState(1);
  const elementsPerPage = 7;

  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };
  const [filterText, setFilterText] = useState("");
  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };
  const filteredData = productos.filter((productos) => {
    return productos.Nombre.toLowerCase().includes(filterText.toLowerCase());
  });
  const [sortType, setSortType] = useState("asc");
  const sortedData = filteredData.sort(sortData(sortType));
  function sortData(sortType) {
    return function (a, b) {
      if (sortType === "asc") {
        return a.Nombre.localeCompare(b.Nombre);
      } else {
        return b.Nombre.localeCompare(a.Nombre);
      }
    };
  }

  const [showProdForm, setShowProdForm] = useState(false);
  const handleCloseProd = () => {
    setShowProdForm(false);
  };

  const addCat = async (e) => {
    setMod("ADD");
    let item = { Nombre: "", "Tipo de unidad": "", Cantidad: 0 };
    setItemProducto(item);
    setShowProdForm(true);
  };
  const updCat = async (item) => {
    setMod("UPD");
    setItemProducto(item);
    setShowProdForm(true);
  };
  const delCat = async (item) => {
    setMod("DLT");
    setItemProducto(item);
    setShowProdForm(true);
  };

  return (
    <div className="container">
      <div className="row">
        <h2 className="page-title">INVENTARIO</h2>

        <div className="container">
          <>
            <br />
            <div className="row">
              <div className="col-sm-3">
                <div className="input-group">
                  <Form.Control
                    className="form-control border-end-0 border rounded-pill"
                    type="text"
                    aria-describedby="search-icon"
                    placeholder="Busqueda general"
                    value={filterText}
                    onChange={handleFilterTextChange}
                  />
                  <span className="input-group-append">
                    <button
                      className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                      type="button"
                    >
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                  </span>
                </div>
              </div>
              <div className="col-sm-12">
                <Table
                  className="table-menu"
                  striped
                  bordered
                  hover
                  border="2"
                  id="ex-tblMenu"
                >
                  <tbody>
                    <tr>
                      <th
                        className="width-tbl60"
                        onClick={() =>
                          setSortType(sortType === "asc" ? "desc" : "asc")
                        }
                      >
                        {" "}
                        <FontAwesomeIcon icon={faSort} /> Nombre
                      </th>
                      <th className="width-tbl10">Cantidad</th>
                      <th className="width-tbl10">Tipo de unidad</th>
                      <th className="width-tbl10">Modificar</th>
                      <th className="width-tbl10">Eliminar</th>
                    </tr>
                    {inventario.productos !== 0
                      ? inventario.productos &&
                        getElementsForPage(currentPage)
                          .sort()
                          .map((val, key) => {
                            return (
                              <tr key={key}>
                                <td>{val.Nombre}</td>
                                <td>{val.Cantidad}</td>
                                <td>{val["Tipo de unidad"]}</td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => updCat(val)}
                                    className="btn btn-primary"
                                  >
                                    <FontAwesomeIcon icon={faPencil} />
                                  </button>
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => delCat(val)}
                                    className="btn btn-danger"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                      : ""}
                  </tbody>
                </Table>
                <Pagination>
                  {Array.from({
                    length: Math.ceil(filteredData.length / elementsPerPage),
                  }).map((page, index) => (
                    <Pagination.Item
                      key={index}
                      active={index + 1 === currentPage}
                      className={
                        index + 1 === currentPage ? "btn-paginado" : ""
                      }
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
              <br />
              <div className="col-sm-12 left">
                <button
                  hidden={!inventario.productos}
                  className="btn btn-primary"
                  onClick={addCat}
                  disabled={newCat}
                >
                  {" "}
                  <FontAwesomeIcon icon={faPlus} /> AGREGAR
                </button>
              </div>
            </div>
          </>
          <br />
          <br />
        </div>

        <ProductoModal
          inventario={inventario}
          showProducto={showProdForm}
          mod={mod}
          itemProducto={itemProducto}
          handleCloseProducto={handleCloseProd}
        ></ProductoModal>
      </div>
    </div>
  );
}
